module.exports = __webpack_public_path__ + "static/consciousness-medicine-a3d3634fd46242959faa6962f41474ee.jpg";